import Search from '@ingka/search';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import { useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
export const QuickSearchInput = (props: { size?: 'medium' | 'small' }) => {
  const apiRef = useGridApiContext();

  const handleSearch = useCallback(
    (_, { value }) => {
      apiRef.current.setQuickFilterValues(
        value.split(' ').filter((word: string) => word !== ''),
      );
    },
    [apiRef],
  );

  const handleClear = useCallback(() => {
    apiRef.current.setQuickFilterValues([]);
  }, [apiRef]);

  return (
    <div style={{ minHeight: '52px', maxWidth: '394px' }}>
      <Search
        actions={null}
        ariaLabel="Search for projects."
        clearBtnText="Clear search field"
        id={uuidv4()}
        data-testid={'project-search'}
        onSearch={handleSearch}
        size={props.size || 'medium'}
        onClear={handleClear}
        placeholder="Search"
        scope={null}
        submitBtnText="Submit"
      />
    </div>
  );
};
